import { PostFeatures } from "./types";

import * as S from "./styles";

const Table = (props: PostFeatures) => {
  return (
    <S.Table>
      <S.Title>{props.title}</S.Title>
      <table>
        <tbody>
          {props.itens?.map((item, i) => (
            <tr key={i}>
              <td>{item.title}</td>
              <td>{item.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </S.Table>
  );
};

export default Table;
